module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAHCAYAAADNufepAAAAFUlEQVQImWP8edruPwMUMDEgAYo5AAz9Aw+5QgM9AAAAAElFTkSuQmCC"